import React from "react";
import get from "lodash/get";
import { Link } from "@quintype/components";
import { object } from "prop-types";

import Headline from "../../atoms/headline";
import ResponsiveSourceImage from "../../atoms/responsive-source-image";

import "./also-read.m.css";

const AlsoRead = ({ story, element }) => {
  const linkedStoryId = get(element, ["metadata", "linked-story", "id"], "");
  const linkedStory = get(story, ["linked-stories", linkedStoryId], {});
  const linkedStorySlug = get(story, ["linked-stories", linkedStoryId, "slug"], "");
  const linkedStoryHeadline = get(story, ["linked-stories", linkedStoryId, "headline"], element.text);
  const noImageClassName = !linkedStory["hero-image-s3-key"] ? "no-image" : "";

  return (
    <Link href={`/${linkedStorySlug}`} className="also-read">
      <div styleName="also-read">
        <Headline text="Also Read" headerType={13} headerLevel={3} />
      </div>

      <div styleName={`wrapper ${noImageClassName}`}>
        {linkedStory["hero-image-s3-key"] && (
          <ResponsiveSourceImage story={linkedStory} desktopAspectRation={[16, 9]} mobileAspectRation={[1, 1]} />
        )}
        <div styleName="content">
          <Headline text={linkedStoryHeadline} headerType={12} headerLevel={4} />
        </div>
      </div>
    </Link>
  );
};

AlsoRead.propTypes = {
  story: object,
  element: object
};

export default AlsoRead;
